<ng-container>
    <app-specialist-record-list
        [folderId]="store.folderId() || 0"
        [extraFolderIds]="store.specialistRecordSharingIds() || []"
        [export]="true"
    ></app-specialist-record-list>
</ng-container>
